<template>
  <div class="wrapper">
    <div class="profile-card__cnt js-profile-cnt">
      <div class="profile-card__name">{{ this.$store.state.user.email }}</div>
      <div class="profile-card__txt">
        Right now you are <strong>the logged user</strong>
      </div>
      <div class="profile-card-inf">
        <div class="profile-card-inf__item">
          <div class="profile-card-inf__title">
            {{ this.$store.state.user.dashboards.length }}
          </div>
          <div class="profile-card-inf__txt">Dashboards</div>
        </div>
        <div class="profile-card-inf__item">
          <div class="profile-card-inf__title">
            {{ totalOfNotes }}
          </div>
          <div class="profile-card-inf__txt">Notes</div>
        </div>
        <div class="profile-card-inf__item">
          <div class="profile-card-inf__title">
            {{ totalOfLinks }}
          </div>
          <div class="profile-card-inf__txt">Links</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Profile",
  components: {},
  computed: {
    totalOfNotes() {
      return this.$store.state.user.dashboards.reduce(
        (total, current) => (total = total + current.notes.length),
        0
      );
    },
    totalOfLinks() {
      return this.$store.state.user.dashboards.reduce(
        (total, current) => (total = total + current.links.length),
        0
      );
    },
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
a,
a:hover {
  text-decoration: none;
}
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
}
.wrapper {
  padding: 50px 20px;
  display: flex;
  display: flex;
  @media screen and (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    padding-top: 100px;
  }
}
.profile-card {
  width: 100%;
  min-height: 460px;
  margin: auto;
  box-shadow: 0px 8px 60px -10px rgba(13, 28, 39, 0.6);
  background: #fff;
  border-radius: 12px;
  max-width: 700px;
  position: relative;
  &.active {
    .profile-card__cnt {
      filter: blur(6px);
    }
    .profile-card-message,
    .profile-card__overlay {
      opacity: 1;
      pointer-events: auto;
      transition-delay: 0.1s;
    }
    .profile-card-form {
      transform: none;
      transition-delay: 0.1s;
    }
  }
  &__img {
    width: 150px;
    height: 150px;
    margin-left: auto;
    margin-right: auto;
    transform: translateY(-50%);
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    z-index: 4;
    box-shadow: 0px 5px 50px 0px rgb(108, 68, 252),
      0px 0px 0px 7px rgba(107, 74, 255, 0.5);
    @media screen and (max-width: 576px) {
      width: 120px;
      height: 120px;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  &__cnt {
    margin-top: -35px;
    text-align: center;
    padding: 0 20px;
    padding-bottom: 40px;
    transition: all 0.3s;
  }
  &__name {
    font-weight: 700;
    font-size: 24px;
    color: #6944ff;
    margin-bottom: 15px;
  }
  &__txt {
    font-size: 18px;
    font-weight: 500;
    color: #324e63;
    margin-bottom: 15px;
    strong {
      //color: #ff2846;
      font-weight: 700;
    }
  }
  &-loc {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    &__icon {
      display: inline-flex;
      font-size: 27px;
      margin-right: 10px;
      //color: #6944ff;
    }
  }
  &-inf {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top: 35px;
    &__item {
      padding: 10px 35px;
      min-width: 150px;
      @media screen and (max-width: 768px) {
        padding: 10px 20px;
        min-width: 120px;
      }
    }
    &__title {
      font-weight: 700;
      font-size: 27px;
      //color: #6944ff;
      color: #7957d5;
    }
    &__txt {
      font-weight: 500;
      margin-top: 7px;
    }
  }

  &-ctr {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    @media screen and (max-width: 576px) {
      flex-wrap: wrap;
    }
  }
  &__button {
    background: none;
    border: none;
    font-family: "Quicksand", sans-serif;
    font-weight: 700;
    font-size: 19px;
    margin: 15px 35px;
    padding: 15px 40px;
    min-width: 201px;
    border-radius: 50px;
    min-height: 55px;
    color: #fff;
    cursor: pointer;
    backface-visibility: hidden;
    transition: all 0.3s;
    @media screen and (max-width: 768px) {
      min-width: 170px;
      margin: 15px 25px;
    }
    @media screen and (max-width: 576px) {
      min-width: inherit;
      margin: 0;
      margin-bottom: 16px;
      width: 100%;
      max-width: 300px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    &:focus {
      outline: none !important;
    }
    @media screen and (min-width: 768px) {
      &:hover {
        transform: translateY(-5px);
      }
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    &.button--blue {
      background: linear-gradient(45deg, #1da1f2, #0e71c8);
      box-shadow: 0px 4px 30px rgba(19, 127, 212, 0.4);
      &:hover {
        box-shadow: 0px 7px 30px rgba(19, 127, 212, 0.75);
      }
    }
    &.button--orange {
      background: linear-gradient(45deg, #d5135a, #f05924);
      box-shadow: 0px 4px 30px rgba(223, 45, 70, 0.35);
      &:hover {
        box-shadow: 0px 7px 30px rgba(223, 45, 70, 0.75);
      }
    }
    &.button--gray {
      box-shadow: none;
      background: #dcdcdc;
      color: #142029;
    }
  }
  &-message {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 130px;
    padding-bottom: 100px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
  }
  &-form {
    box-shadow: 0 4px 30px rgba(15, 22, 56, 0.35);
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 35px;
    transform: scale(0.8);
    position: relative;
    z-index: 3;
    transition: all 0.3s;
    @media screen and (max-width: 768px) {
      max-width: 90%;
      height: auto;
    }
    @media screen and (max-width: 576px) {
      padding: 20px;
    }
    &__bottom {
      justify-content: space-between;
      display: flex;
      @media screen and (max-width: 576px) {
        flex-wrap: wrap;
      }
    }
  }
  textarea {
    width: 100%;
    resize: none;
    height: 210px;
    margin-bottom: 20px;
    border: 2px solid #dcdcdc;
    border-radius: 10px;
    padding: 15px 20px;
    color: #324e63;
    font-weight: 500;
    font-family: "Quicksand", sans-serif;
    outline: none;
    transition: all 0.3s;
    &:focus {
      outline: none;
      border-color: #8a979e;
    }
  }
  &__overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    opacity: 0;
    background: rgba(22, 33, 72, 0.35);
    border-radius: 12px;
    transition: all 0.3s;
  }
}
</style>
